import { PaginatedQueryResponse } from '@/types/api'
import { IWorkArea } from '@/types/work-area'
import { ApiService } from './ApiService'

export type { IWorkArea }

export class WorkAreaService extends ApiService {
  static GET_PATH = '/work-areas'

  static async getWorkAreas(): Promise<PaginatedQueryResponse<IWorkArea>> {
    return ApiService.get(WorkAreaService.GET_PATH)
  }
}
